import { useNotificationStore } from '../../store/useNotificationStore';
import { InAppNotificationCard } from './InAppNotificationCard';

export function InAppNotifications() {
  const { notifications } = useNotificationStore();

  if (notifications.length === 0) return null;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        maxHeight: '100%',
        overflowY: 'auto'
      }}
    >
      {notifications.map((notification) => (
        <InAppNotificationCard key={notification.id} notification={notification} />
      ))}
      <style>{`
        @keyframes slideIn {
          from {
            transform: translateX(20px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
}
